import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { DvSpinnerComponent } from '@devinco/ui/dds';
import { TranslatePipe } from '@ngx-translate/core';
import { ActiveVippsUIStatus } from '@shared/interfaces/vipps';

@Component({
  selector: 'app-vipps-status',
  imports: [DvSpinnerComponent, TranslatePipe],
  templateUrl: './vipps-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './vipps-status.component.scss',
})
export class VippsStatusComponent {
  status = input<ActiveVippsUIStatus>(undefined);
  cancel = output<void>();
}
